import { render, staticRenderFns } from "./objects-table.vue?vue&type=template&id=4a261e26&lang=pug&"
import script from "./objects-table.vue?vue&type=script&lang=js&"
export * from "./objects-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports